export const SKELETON_MIN_TIME = 2000;
